import React from 'react';

const WhyCheqrboard: React.FC = () => {
  return (
    <section className='flex flex-col w-auto px-4 md:px-10 py-2 bg-[#fafafa]'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        {/* Header */}
        <div className='flex flex-col items-center justify-start mt-2 md:mt-10'>
          <strong className='text-3xl text-center md:text-4xl'>
            Why CheQRboard
          </strong>
          <div className='flex mt-4 text-center md:w-3/4'>
            <p className='text-lg'>
              With customizable multimedia templates and comprehensive analytics, the CheQRboard Platform empowers cultural attractions and venue owners to 
              educate and engage their visitors with fresh content and experiences, connect on a deeper level, and generate additional revenue
            </p>
          </div>
        </div>

        {/* Card List */}
        <div className='grid items-center justify-center grid-cols-1 md:mx-2 my-10 md:grid-cols-2 gap-x-10 gap-y-10'>
          {/* Card */}
          <div className='w-auto p-10 rounded-2xl border border-[#1d191f] shadow-md'>
            <div className='flex flex-row items-center justify-start space-x-4'>
              <div className='flex flex-col items-center justify-center p-4 rounded-lg bg-[#89f5a0] w-18 h-18'>
                <img
                  className='relative w-18'
                  alt=''
                  src={'/unlock-revenue.svg'}
                />
              </div>
              <strong className='text-2xl'>Unlock Revenue</strong>
            </div>
            <p className='mt-6 text-lg'>
              Collect and analyze visitor data to inform strategies that increase revenue and sales
            </p>
          </div>

          {/* Card */}
          <div className='w-auto p-10 rounded-2xl border border-[#1d191f] shadow-md'>
            <div className='flex flex-row items-center justify-start space-x-4'>
              <div className='flex flex-col items-center justify-center p-4 rounded-lg bg-[#89f5a0] w-18 h-18'>
                <img
                  className='relative w-18'
                  alt=''
                  src={'/educate-inspire.svg'}
                />
              </div>
              <strong className='text-2xl'>Educate & Inspire</strong>
            </div>
            <p className='mt-6 text-lg'>
              Create dazzling, interactive content that educates visitors and inspires support of your cause
            </p>
          </div>

          {/* Card */}
          <div className='w-auto p-10 rounded-2xl border border-[#1d191f] shadow-md'>
            <div className='flex flex-row items-center justify-start space-x-4'>
              <div className='flex flex-col items-center justify-center p-4 rounded-lg bg-[#89f5a0] w-18 h-18'>
                <img
                  className='relative w-18'
                  alt=''
                  src={'/increase-engagement.svg'}
                />
              </div>
              <strong className='text-2xl'>Increase Engagement</strong>
            </div>
            <p className='mt-6 text-lg'>
              Use built-in analytics to gain insights into behavior to optimize their experience
            </p>
          </div>

          {/* Card */}
          <div className='w-auto p-10 rounded-2xl border border-[#1d191f] shadow-md'>
            <div className='flex flex-row items-center justify-start space-x-4'>
              <div className='flex flex-col items-center justify-center p-4 rounded-lg bg-[#89f5a0] w-18 h-18'>
                <img
                  className='relative w-18'
                  alt=''
                  src={'/increase-membership.svg'}
                />
              </div>
              <strong className='text-2xl'>Increase Membership</strong>
            </div>
            <p className='mt-6 text-lg'>
              Communicate directly with visitors and engage them with your mission, in and out of the venue
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyCheqrboard;
